// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2X4gx","actionsCol":"EnrolledClinics_actionsCol__3lA5c"};